import type { IClickmapSorted } from '@gem-sdk/heatmap-react';

import { BlockStack, Box, InlineStack, Text } from '@shopify/polaris';
import { useHeatmapClickContext } from '@gem-sdk/heatmap-react';
import { RankedMetricItem } from './RankedMetricItem';
import { useCallback, memo, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { GDiv } from '~/presentation/ui';
import { RankBadge } from '../../Common';

interface ClickRankItemProps {
  rank: number;
  item: IClickmapSorted;
}

export const ClickRankItem = memo(
  forwardRef<HTMLDivElement, ClickRankItemProps>(({ rank, item }, ref) => {
    const { hash, selector } = item;

    const isSelected = useHeatmapClickContext((s) => s.selectedElement?.hash === hash);
    const setSelectedElement = useHeatmapClickContext((s) => s.setSelectedElement);

    const { t } = useTranslation();

    const handleClick = useCallback(() => {
      setSelectedElement(hash);
    }, [hash, setSelectedElement]);

    return (
      <GDiv
        ref={ref}
        data-hashbeta={hash}
        className="Heatmap-Ranked_Item"
        data-selected={isSelected}
        onClick={handleClick}
      >
        <Box padding="300" overflowX="hidden">
          <InlineStack blockAlign="start" gap="200" wrap={false}>
            <RankBadge rank={rank} tone={isSelected ? 'dark' : 'light'} />
            <Box maxWidth="100%" overflowX="hidden">
              <BlockStack gap="100">
                <Text as="p" truncate variant="bodyMd" fontWeight="semibold">
                  {selector || t('Unnamed')}
                </Text>
                <RankedMetricItem item={item} />
              </BlockStack>
            </Box>
          </InlineStack>
        </Box>
      </GDiv>
    );
  }),
);
